module.exports = __webpack_public_path__ + "static/media/Notificacao.8876f629.svg";